<script setup>
const modalFlag = ref(false)

function openModal() {
  modalFlag.value = true
  document.body.style.overflow = 'hidden'
  document.documentElement.style.overflow = 'hidden'
}

function closeModal() {
  modalFlag.value = false
  document.body.style.overflow = 'auto'
  document.documentElement.style.overflow = 'auto'
}
</script>

<template>
  <div>
    <p
      class="legendIcon"
      @click="openModal"
    >
      アイコンの説明
    </p>
    <div
      v-show="modalFlag"
      class="legendModal"
      style="display: none;"
    >
      <div class="inner">
        <button
          class="close"
          @click="closeModal"
        />
        <div
          class="card"
        >
          <div
            class="legend"
          >
            <p
              class="title"
            >
              服装指数
            </p><ul
              class="content"
            >
              <li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_00.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    ノースリーブ
                  </p><p
                    class="text"
                  >
                    ノースリーブ１枚でも過ごせる暑さです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_01.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    Tシャツ1枚
                  </p><p
                    class="text"
                  >
                    Tシャツ1枚でも過ごせる暑さです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_02.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    半袖シャツ1枚
                  </p><p
                    class="text"
                  >
                    厚手の半袖Tシャツや襟付きの半袖シャツ1枚くらいがちょうどいい暑さです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_03.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    長袖シャツ1枚
                  </p><p
                    class="text"
                  >
                    長袖シャツ1枚くらいで快適に過ごせそうです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_04.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    カーディガン
                  </p><p
                    class="text"
                  >
                    長袖Tシャツなどの上に、薄手の羽織るものがあると快適に過ごせそうです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_05.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    薄手セーター
                  </p><p
                    class="text"
                  >
                    長袖Tシャツなどシャツの上に薄手のセーター1枚重ねるくらいで快適に過ごせそうです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_06_spring.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure><figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_06_winter.webp"
                      alt=""
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    厚手セーター（厚手スウェット）
                  </p><p
                    class="text"
                  >
                    長袖Tシャツなどシャツの上に厚手のセーターやスウェットなど、熱を逃しにくいものを重ねるなど暖かな服装がちょうど良さそうです。薄手のニットに軽いジャケット羽織るのもおすすめです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_07.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    薄手コート
                  </p><p
                    class="text"
                  >
                    裏地の無いような春秋向けのやや薄手のアウターやジャケットなどの上着があるとちょうど良く過ごせそうです。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_08.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    厚手コート
                  </p><p
                    class="text"
                  >
                    裏地のあるしっかりとした冬物の厚手コートがあると暖かに過ごせそうです。風が冷たい日はさらに、手袋や帽子など防寒対策があると安心です。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/clothes/tops_09.webp"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    ダウンコート
                  </p><p
                    class="text"
                  >
                    ダウンコートなど風や冷気を通さず、保温効果が高いアウターが重宝する寒さです。必要に応じて手袋やニット帽で防寒すると良さそうです。
                  </p>
                </div>
              </li>
            </ul>
          </div><div
            class="legend"
          >
            <p
              class="title"
            >
              昼間・朝晩のアイコン表示ルール
            </p><p
              class="text"
            >
              今日明日の予報においては以下のルールで表示しています。
            </p><ul
              class="content"
            >
              <li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/icon/icon_day.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    「昼間」の服装予報
                  </p><p
                    class="text"
                  >
                    昼10時〜15時の間で最も薄着になる予報を表示しています。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/clothes/images/icon/icon_night.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    「朝晩」の服装予報
                  </p><p
                    class="text"
                  >
                    朝（出勤時間）7時〜9時、または夜（帰宅時間）16時〜21時において最も厚着になる予報を表示しています。
                  </p>
                </div>
              </li>
            </ul>
          </div><div
            class="legend"
          >
            <p
              class="title"
            >
              傘指数
            </p><ul
              class="content"
            >
              <li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/onebox/img/common/icon_prec_04.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    傘必須
                  </p><p
                    class="text"
                  >
                    降水確率が90%以上で傘が必須です。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/onebox/img/common/icon_prec_03.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    長傘
                  </p><p
                    class="text"
                  >
                    降水確率が70%以上と高く、長傘が必要です。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/onebox/img/common/icon_prec_02.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    折り畳み傘
                  </p><p
                    class="text"
                  >
                    降水確率が20%以上と雨の可能性があるため、折り畳み傘が必要です。
                  </p>
                </div>
              </li><li
                class="list"
              >
                <div
                  class="image"
                >
                  <figure>
                    <img
                      src="https://gvs.weathernews.jp/onebox/img/common/icon_prec_01.svg"
                      width="30"
                      height="30"
                      loading="lazy"
                    >
                  </figure>
                </div><div
                  class="textarea"
                >
                  <p
                    class="name"
                  >
                    必要なし
                  </p><p
                    class="text"
                  >
                    降水確率が20%未満で雨の可能性は低いので、傘は必要ありません。
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  <style lang="scss" scoped>
.legendIcon {
        position: relative;
        float: right;
        margin-top: -20px;
        margin-left: auto;
        padding-left: 20px;
        background-image: url("https://gvs.weathernews.jp/clothes/images/icon/icon_legend.svg");
        background-position: left center;
        background-repeat: no-repeat;
        background-size: 15px;
        color: #3569c0;
        line-height: 1em;
        text-decoration: underline;
      }

  .legendModal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100svh;
    background-color: rgb(0 0 0 / .33);
    z-index: 100;
    .inner {
      position: relative;
      width: 100%;
      height: 100%;
      max-width: min(90%, 660px);
      margin-inline: auto;
      padding: 40px 0;
    }
    .close {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 15px;
      right: 0;
      cursor: pointer;
      &::before,
      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 24px;
        height: 3px;
        border-radius: 100vmax;
        background-color: #fff;
        content: '';
      }
      &::before {
        transform: translate(-50%, -50%) rotate(-45deg);
      }
      &::after {
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }
    .card {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 100%;
      height: 100%;
      padding: 25px 15px;
      background-color: #fff;
      border-radius: 8px;
      overflow-y: scroll;
      scrollbar-width: thin;
      scrollbar-color: #3569c0 transparent;
    }
    .legend {
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-bottom: solid 1px rgb(#808080, .3);
      .content {
        display: flex;
        flex-direction: column;
      }
      .list {
        padding-block: 8px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-top: solid 1px rgb(#808080, .3);
      }
      .image {
        display: flex;
        flex-direction: column;
        gap: 10px;
        figure {
          width: 30px;
        }
        img {
          width: 100%;
          height: auto;
        }
      }
      .textarea {
        display: flex;
        flex-direction: column;
        gap: 5px;
        flex: 1;
      }
      .name {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.2em;
      }
      .text {
        font-size: 12px;
        line-height: 1.5em;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
    }
    @media (any-hover: hover) {
      .search {
        .list {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
    }
    @media screen and (min-width: 830px) {
      .inner {
        padding: 50px 30px;
      }
      .close {
        width: 25px;
        height: 25px;
        top: 15px;
        right: 30px;
        &::before,
        &::after {
          width: 35px;
          height: 4px;
        }
      }
      .card {
        width: auto;
      }
      .legend {
        .list {
          .image {
            figure {
              width: 80px;
            }
          }
        }
        .name {
          font-size: 18px;
        }
        .text {
          font-size: 15px;
        }
      }
      .title {
        font-size: 20px;
      }
    }
  }
  </style>
